var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "mb-3" },
    [
      _c(
        "custom-callout",
        { attrs: { "border-color": "secondary-2", "has-toggle": false } },
        [
          _c("div", { staticClass: "row p-2" }, [
            _c("div", { staticClass: "col-md-2" }, [
              _c("div", { staticClass: "color-secondary-6 font-14" }, [
                _vm._v(" Año Académico: ")
              ]),
              _c(
                "div",
                { staticClass: "font-weight-bold color-black font-14" },
                [_vm._v(" " + _vm._s(_vm.data.academicYear) + " ")]
              )
            ]),
            _c("div", { staticClass: "col-md-2" }, [
              _c("div", { staticClass: "color-secondary-6 font-14" }, [
                _vm._v(" Área: ")
              ]),
              _c(
                "div",
                { staticClass: "font-weight-bold color-black font-14" },
                [_vm._v(" " + _vm._s(_vm.data.area) + " ")]
              )
            ]),
            _c("div", { staticClass: "col-md-2" }, [
              _c("div", { staticClass: "color-secondary-6 font-14" }, [
                _vm._v(" Tipo de Proveedor: ")
              ]),
              _c(
                "div",
                { staticClass: "font-weight-bold color-black font-14" },
                [_vm._v(" " + _vm._s(_vm.data.recruitmentName) + " ")]
              )
            ]),
            _c("div", { staticClass: "col-md-2" }, [
              _c("div", { staticClass: "color-secondary-6 font-14" }, [
                _vm._v(" Fecha de Última Actualización: ")
              ]),
              _c(
                "div",
                { staticClass: "font-weight-bold color-black font-14" },
                [
                  _vm._v(
                    " " + _vm._s(_vm._f("date")(_vm.data.lastUpdateDate)) + " "
                  )
                ]
              )
            ]),
            _c("div", { staticClass: "col-md-2" }, [
              _c("div", { staticClass: "color-secondary-6 font-14" }, [
                _vm._v(" Usuario: ")
              ]),
              _c(
                "div",
                { staticClass: "font-weight-bold color-black font-14" },
                [_vm._v(" " + _vm._s(_vm.data.userFullName) + " ")]
              )
            ]),
            _c(
              "div",
              {
                staticClass:
                  "col-md-2 text-right d-flex justify-content-end pr-4 align-items-center"
              },
              [
                _c("action-button", {
                  staticClass: "ml-3",
                  attrs: {
                    i: "fas fa-file-import",
                    text: "Entrar",
                    variant: "outline-success"
                  },
                  on: { click: () => this.onEditHandler() }
                })
              ],
              1
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }